import { getMenusList } from '@/api/company'
import { getUserInfo } from '@/api/login/login'
import { useUser } from '@/store/user'
import { APICODE } from '@/util/constant'
import { saveCompanyId } from '@/util/http'
// import { getDataFromList } from '@/util/tree'
import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home/HomePage.vue'),
    meta: {
      title: '首页'
    },
    children: [
      {
        path: '/index',
        component: () => import('../views/index/IndexHe.vue')
      }
    ]
  },
  {
    path: '/order/detail/:id',
    name: 'OrderDetail',
    component: () => import('../views/order/orderDetail.vue'),
    meta: {
      title: '订单明细'
    }
  },
  {
    path: '/bike/rentStatDetail/:date',
    name: 'BikeRentStatDetail',
    component: () => import('../views/bike/bikeRentStatDetail.vue'),
    meta: {
      title: '在租车辆明细'
    }
  },
  {
    path: '/bike',
    component: () => import('../views/home/HomePage.vue'),
    children: [
      {
        path: 'bikeRentStat',
        component: () => import('../views/bike/bikeRentStat.vue'),
        meta: {
          title: '租车统计'
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/LoginPage.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/index'
  }
]

function isTokenValid() {
  const token = localStorage.getItem('token')
  return token ? true : false
}

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  console.log('跳转的路由地址1', to.fullPath)

  const userStore = useUser()

  if (to.path == '/login') {
    next()
  } else if (!isTokenValid) {
    next('/login')
  } else if (to.path !== '/login' && !isTokenValid()) {
    next('/login')
  } else if (userStore.menus.length == 0 && isTokenValid) {
    getUserInfo().then((res) => {
      if (res.code == APICODE.SUCCESS) {
        let data = res.data
        const userStore = useUser()
        userStore.updateInfo(data)

        if (localStorage.getItem('cid') == undefined) {
          userStore.companyInfo = data.companys[0]
          saveCompanyId(data.companys[0].id)
        } else {
          const cId = localStorage.getItem('cid')
          const list = data.companys.filter((item) => item.id == cId)
          if (list.length > 0) {
            userStore.companyInfo = list[0]
            saveCompanyId(list[0].id)
          } else {
            userStore.companyInfo = data.companys[0]
            saveCompanyId(data.companys[0].id)
          }
        }

        getMenusList().then((res) => {
          if (res.code == APICODE.SUCCESS) {
            // userStore.menus = getDataFromList(res.data)

            userStore.menus = res.data
            userStore.menus.forEach((item) => {
              const children = item.children.filter((sub) => {
                if (sub.path == 'accountList' && sub.component == 'accountList') {
                  return false
                }
                if (sub.component == 'orderDetail') {
                  return false
                }
                return true
              })
              router.addRoute({
                path: '/' + item.path,
                component: () => import('../views/home/HomePage.vue'),
                children: children.map((sub) => ({
                  path: '/' + item.path + '/' + sub.path,
                  component: () => import(`../views/${item.component}/${sub.component}.vue`)
                }))
              })
            })
            console.log('跳转的路由地址2', to.fullPath)
            next(to.fullPath)
          } else {
            next('/login')
          }
        })
      }
    })
  } else {
    if (to.meta.title) {
      document.title = to.meta.title
    } else {
      document.title = '租赁后台管理系统'
    }
    console.log('跳转的路由地址3333', to.fullPath)

    next()
  }
})

export default router
